import { EToastType } from '@bfe/moly';
import { sha256 } from 'js-sha256';

import {
  ERROR_CODE,
  FORBIDDEN_LOGIN_CODES,
} from '@/utils/constants/sub-account';
import { SubAccountLoginErrorTrack } from '@/utils/trace-list/subAccount';

/**
 * 格式化登录接口参数
 * @returns 登录接口参数
 */
export const formatParams = ({
  captchaData,
  loginInfo,
  risk_token,
  google2faCode,
  bizToken = '',
}: {
  captchaData: any;
  loginInfo: { loginName: string; password: string };
  risk_token: string;
  google2faCode: string;
  bizToken: string;
}) => {
  let otherParms = {};
  // 如果是喜鹊系统，传入喜鹊系统的参数
  if (captchaData?.magpie_verify_info) {
    otherParms = captchaData;
  }
  // 短信验证
  let targetType = null;
  if (captchaData?.type === 'qqcaptcha') {
    targetType = 3;
  } else if (captchaData?.type === 'recaptcha') {
    targetType = 4;
  } else {
    targetType = null;
  }
  const params = {
    loginName: loginInfo.loginName,
    password: sha256(loginInfo.password),
    loginType: 1,
    bizToken: bizToken,
    risk_token,
    authContext: [
      {
        target: {
          type: targetType,
          target: '',
        },
        answer: {
          response:
            targetType === 3
              ? captchaData.ticket
              : captchaData.g_recaptcha_response,
          tencentRandstr: captchaData.randstr || '', // qq 的才有, google 的没有
        },
      },
      {
        target: {
          type: 5,
          targetExt: {
            loginName: loginInfo.loginName, // 登录名 必填
            countryCode: '', // 目前不填
          },
        },
        answer: {
          response: google2faCode,
        },
      },
    ],
    ...otherParms,
  };
  return params;
};

/**
 * 登录失败处理
 * forbiddenLogin：土耳其或者香港用户在主站登录子账号，或者主站用户在香港站或者土耳其站登录子账号，弹窗提示
 * errorTimeToast：账号或者密码错误次数toast提示，只有最后两次需要提示
 * limitModal：账号密码输入错误次数太多，帐户锁定弹窗提示
 * errorToast：通用错误toast提示
 */
export const loginCatch = ({
  err,
  errorToast,
  limitModal,
  forbiddenLogin,
  errorTimeToast,
  need2faVerify,
}: {
  err: any;
  forbiddenLogin: (ret_code: number) => void;
  errorToast: (params: {
    errorCode: number;
    title?: string;
    ns?: string;
  }) => void;
  limitModal: () => void;
  need2faVerify: (bizToken: string) => void;
  errorTimeToast: (ret_code: number, times: string) => void;
}) => {
  try {
    const { ret_code, ext_code, ret_msg, result } = err;
    if (FORBIDDEN_LOGIN_CODES.includes(ret_code)) {
      forbiddenLogin(ret_code);
      return;
    }

    if (ret_code === ERROR_CODE.USERNAME_PASSWORD_ERROR_TIMES) {
      const { pass_err_count } = result?.userInfoResult || {};
      if (pass_err_count && (pass_err_count === 3 || pass_err_count === 4)) {
        errorTimeToast(ret_code, String(5 - Number(pass_err_count)));
        return;
      }
    }

    if (ret_code === ERROR_CODE.USERNAME_PASSWORD_ERROR_LIMIT) {
      limitModal();
      return;
    }

    if (ret_code === ERROR_CODE.NEED_2FA) {
      need2faVerify(ext_code);
      return;
    }

    if (ret_code && ret_code === ERROR_CODE.USER_BANNED) {
      errorToast({
        errorCode: ret_code,
        title: ret_msg,
      });
      return;
    }

    if (
      ret_code &&
      ret_code !== ERROR_CODE.NEED_2FA &&
      ret_code !== ERROR_CODE.USER_BANNED
    ) {
      errorToast({
        errorCode: ret_code,
        ns: 'inverse-error-code',
      });
      SubAccountLoginErrorTrack(err);
    }
  } catch (error) {
    errorToast({
      errorCode: -200,
      title: 'noLoginP3',
      ns: 'user-service-nextjs',
    });
    SubAccountLoginErrorTrack(error);
  }
};
